// extracted by mini-css-extract-plugin
module.exports = {"authLayout":"authLayout--83ix-","authLayoutWhite":"authLayoutWhite--3ZjWz"};